"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginScreen = LoginScreen;
const react_1 = __importDefault(require("react"));
const core_1 = require("../core");
const defaultLogo_1 = require("./defaultLogo");
require("./styles.css");
const DEFAULT_COMPANY_NAME = "Home Health Notify";
function LoginScreen({ logoSrc, companyName, productName, colorScheme, }) {
    const { isValidatingSession, error, signIn } = (0, core_1.useAuth)();
    const resolvedLogo = logoSrc === undefined ? defaultLogo_1.DEFAULT_LOGO_DATA_URI : logoSrc;
    const resolvedName = companyName === undefined ? DEFAULT_COMPANY_NAME : companyName;
    return (react_1.default.createElement("div", { className: "hhn-auth-screen", "data-hhn-auth-theme": colorScheme },
        react_1.default.createElement("div", { className: "hhn-auth-content" },
            resolvedLogo ? (react_1.default.createElement("img", { className: "hhn-auth-logo", src: resolvedLogo, alt: resolvedName !== null && resolvedName !== void 0 ? resolvedName : "Logo" })) : null,
            resolvedName ? (react_1.default.createElement("h1", { className: "hhn-auth-company-name" }, resolvedName)) : null,
            productName ? (react_1.default.createElement("p", { className: "hhn-auth-product-name" }, productName)) : null,
            error ? react_1.default.createElement("div", { className: "hhn-auth-error" }, error) : null,
            react_1.default.createElement("button", { type: "button", className: "hhn-auth-button", disabled: isValidatingSession, onClick: () => {
                    signIn().catch(() => undefined);
                } }, "Sign in"))));
}
